export const doesWebsiteHasPopups = (website: any) => {
    const popupItemList = website.popups.items;
    if (!popupItemList) return false;
    if (popupItemList.length === 0) return false;
    return true;
}